import {
    configureStore,
    combineReducers,
} from '@reduxjs/toolkit'
import { searchPartnersApi } from './modules/services/searchPartnersApi/searchPartnersApi';

import translationsReducer from './modules/translations/reducer'
import uiSliceActionsReducer  from './modules/ui/reducer';
import filtersSliceReducer  from './modules/filters/reducer';
import fhwSliceReducer  from './modules/fhw/reducer';
import mapSliceReducer from './modules/map/reducer';

const rootReducer = combineReducers({
    translations: translationsReducer,
    ui: uiSliceActionsReducer,
    filters: filtersSliceReducer,
    partners: fhwSliceReducer,
	map: mapSliceReducer,
    [searchPartnersApi.reducerPath]: searchPartnersApi.reducer
})

// export type RootState = typeof rootReducer;
export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(searchPartnersApi.middleware),
    devTools: process.env.NODE_ENV !== 'production',
})

// investigate: setupListeners

export default store
